"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.multiPartUpdate = exports.TransactionBuilder = void 0;
const Logger_1 = require("./Logger");
const error_1 = require("./error");
class TransactionBuilder {
    constructor(trans, prev, first) {
        this.name = trans.name;
        this.run = trans.execute;
        this.rollback = trans.rollback;
        this.first = (first || this);
        this.prev = prev;
    }
    then(next) {
        this.next = new TransactionBuilder(next, this, this.first);
        return this.next;
    }
    execute(input) {
        return __awaiter(this, void 0, void 0, function* () {
            return this._execute(this.first, input);
        });
    }
    performRollback() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            yield ((_a = this.rollback) === null || _a === void 0 ? void 0 : _a.call(undefined, this.exeResult));
            yield ((_b = this.prev) === null || _b === void 0 ? void 0 : _b.performRollback());
        });
    }
    _execute(target, input) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            try {
                target.exeResult = yield target.run.call(undefined, input);
            }
            catch (e) {
                Logger_1.logger.warn({
                    message: 'Transaction failed. Rolling back...',
                    stack: (0, error_1.getStackTrace)(e),
                    cause: e.cause,
                    errorType: e.errorType,
                    data: {
                        name: target.name,
                        input,
                    },
                });
                try {
                    yield ((_a = target.prev) === null || _a === void 0 ? void 0 : _a.performRollback());
                }
                catch (_b) {
                    Logger_1.logger.error({
                        message: 'Rollback failed. Terminating...',
                        stack: (0, error_1.getStackTrace)(e),
                        cause: e.cause,
                        errorType: e.errorType,
                        data: {
                            name: this.name,
                            executionResult: this.exeResult,
                        },
                    });
                }
                throw e;
            }
            if (target.next) {
                return yield target.next._execute(target.next, target.exeResult);
            }
            else {
                return target.exeResult;
            }
        });
    }
}
exports.TransactionBuilder = TransactionBuilder;
function multiPartUpdate(firstTransaction) {
    return new TransactionBuilder(firstTransaction);
}
exports.multiPartUpdate = multiPartUpdate;
